export default "__VITE_PUBLIC_ASSET__732f0fad__"